const firebaseConfig = {
    apiKey: "AIzaSyDBNzFxGLevWWfhG8wfSDR3kWey08KuhNo",
    authDomain: "interactive-comments-sec-8b0ed.firebaseapp.com",
    databaseURL: "https://interactive-comments-sec-8b0ed-default-rtdb.firebaseio.com",
    projectId: "interactive-comments-sec-8b0ed",
    storageBucket: "interactive-comments-sec-8b0ed.appspot.com",
    messagingSenderId: "1048841328785",
    appId: "1:1048841328785:web:85cb9d6495c05877c60730",
    measurementId: "G-XD74Z897B5"
  };
  
export default firebaseConfig;
  